import { render, staticRenderFns } from "./addActivity.vue?vue&type=template&id=b5170eb4&scoped=true"
import script from "./addActivity.vue?vue&type=script&lang=js"
export * from "./addActivity.vue?vue&type=script&lang=js"
import style0 from "./addActivity.vue?vue&type=style&index=0&id=b5170eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5170eb4",
  null
  
)

export default component.exports